<template>
  <div id="bg-image">
    <passcode-reset-page />
  </div>
</template>

<script>
import PasscodeResetPage from '../process/Register/PasscodeResetPage.vue';
  export default {
    name: 'ConfirmMobileNumber',
    components: {
      PasscodeResetPage,
    },
  };
</script>

<style scoped>

</style>
